module.exports = __webpack_public_path__ + "media/images/porsche-vector-logo-57efdcfca3725a67e7002c60cd7bc808.svg";